import { FeatureFlags } from '@/featureFlags';

// Returns true if both:
// 1. the "escapeIframe" feature flag is true, and
// 2. the current window is in an iframe (i.e., it's not the top window).
// @workaround For extra safety, avoid infinite loops by checking if we ourselves were launched.
export const shouldRelaunchInNewWindow = () =>
  !!FeatureFlags.escapeIframe && window.top !== window.self && !window.opener;

// Opens a new browser window/tab to the current URL.
// If an existing window's name is given, then tries to give that window focus.
export const relaunchInNewWindow = (windowName?: string) => {
  try {
    const newWin = window.open(window.location.href, windowName || '_blank');
    newWin?.focus();
    return true;
  } catch (err) {
    console.error('relaunchInNewWindow: error opening new browser window', windowName, err);
    return false;
  }
};
